import React, { useEffect } from 'react';
import { Route, Redirect, Switch } from 'react-router-dom';
import { FingotiNotFound, FingotiLoading } from '@fingoti/components';
import { RequireAuth, useFingotiAuth } from '@fingoti/auth-js/react';

import Layout from './components/Layout';
import { User } from './components/User/User';
import { Organisation } from './components/Organisation/Organisation';
import { Billing } from './components/Billing/Billing';
import { Logout } from './components/Login/Logout';
import { Callback } from './components/Auth/Callback';

import { useProfileState } from './context/ProfileContext';
import { ProfileData } from './context/ProfileData';

import './main.css';

const Protected = ({ children }) => (
	<RequireAuth fallback={<FingotiLoading fullHeight />}>{children}</RequireAuth>
);

const App = () => {
	const profileData = ProfileData();
	const { isAuthenticated } = useFingotiAuth();
	const { user } = useProfileState();

	useEffect(() => {
		if (isAuthenticated && !user) {
			profileData.getData();
		}
	}, [isAuthenticated, user]);

	return (
		<div className='App'>
			<Layout>
				<Switch>
					<Route exact path='/auth/callback' component={Callback} />
					<Route exact path='/logout' component={Logout} />
					<Route exact path='/'>
						<Redirect to='/organisation' />
					</Route>

					<Route exact path='/organisation'>
						<Protected><Organisation activeMenu={0} /></Protected>
					</Route>
					<Route exact path='/organisation/manage'>
						<Protected><Organisation activeMenu={1} /></Protected>
					</Route>
					<Route exact path='/organisation/users'>
						<Protected><Organisation activeMenu={2} /></Protected>
					</Route>
					<Route exact path='/organisation/roles'>
						<Protected><Organisation activeMenu={3} /></Protected>
					</Route>
					<Route exact path='/organisation/addresses'>
						<Protected><Organisation activeMenu={4} /></Protected>
					</Route>
					<Route exact path='/organisation/tokens'>
						<Protected><Organisation activeMenu={5} /></Protected>
					</Route>
					<Route exact path='/organisation/tenants'>
						<Protected><Organisation activeMenu={6} /></Protected>
					</Route>
					<Route exact path='/organisation/applications'>
						<Protected><Organisation activeMenu={7} /></Protected>
					</Route>

					<Route exact path='/user'>
						<Protected><User activeMenu={0} /></Protected>
					</Route>
					<Route path='/user/sessions'>
						<Protected><User activeMenu={1} /></Protected>
					</Route>
					<Route path='/user/tokens'>
						<Protected><User activeMenu={2} /></Protected>
					</Route>
					<Route path='/user/security'>
						<Protected><User activeMenu={3} /></Protected>
					</Route>

					<Route exact path='/billing'>
						<Protected><Billing activeMenu={0} /></Protected>
					</Route>
					<Route exact path='/billing/cards'>
						<Protected><Billing activeMenu={1} /></Protected>
					</Route>
					<Route exact path='/billing/invoices'>
						<Protected><Billing activeMenu={2} /></Protected>
					</Route>

					{/* Keep at bottom */}
					<Route component={FingotiNotFound} />
				</Switch>
			</Layout>
		</div>
	);
};

export default App;
